import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { InfoStringForm } from './InfoStringForm';
import environment from '../../lib/RelayUtils';
import * as InfoStringAddMutation from '../../mutations/InfoStringAddMutation';

const bodyStyle = { backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' };

export const InfoStringCreate = withRouter(props => {
	const { history } = props;
	const [snackbarMessage, setSnackbarMessage] = useState(undefined);
	const onSubmit = data => {
		InfoStringAddMutation.commit(environment, data, (error: ?Error) => {
			if (error) {
				setSnackbarMessage('Ошибка во время сохранения');
			} else {
				setSnackbarMessage('Запись успешно создана');
				history.push(`/info-strings`);
			}
		});
	};

	const handleCloseSnackbar = () => setSnackbarMessage(undefined);

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<InfoStringForm initialValues={{ order: 1 }} viewer={props.viewer} isCreation={true} onSubmit={onSubmit} />
			{snackbarMessage && <Snackbar open={true} bodyStyle={bodyStyle} message={snackbarMessage} onRequestClose={handleCloseSnackbar} />}
		</Paper>
	);
});


// WEBPACK FOOTER //
// src/components/info-strings/InfoStringCreate.js